module.exports = __webpack_public_path__ + "static/img/data.ed0530b9.png";